import RadioListField from '@acorn-portal/shared/src/components-v2/inputs/radio-list-field';
import { ArrowBack } from '@mui/icons-material';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Form, Formik, FormikConfig } from 'formik';
import { CancellationReason, ReasonForCancellation } from '../../types';
import ActionButtonWrapper from '../action-button-wrapper';
import CancellationReasonInfoText from '../cancellation-reason-info-text';
import { FormikLogErrors } from '@acorn-portal/shared/src/pages/mta/components/FormikLogErrors';

export type CancellationReasonFormValues = {
	reason: ReasonForCancellation | undefined;
};

interface IProps {
	initialValues: CancellationReasonFormValues;
	dropdowns: {
		reason: { label: string; value: CancellationReason }[];
	};
	validationSchema: FormikConfig<CancellationReasonFormValues>['validationSchema'];
	handleSubmit: (values: CancellationReasonFormValues) => void;
	handleBack: (journeyStarted: boolean) => void;
	contactNumber: string;
}

const CancellationReasonForm = ({
	initialValues,
	validationSchema,
	dropdowns,
	handleSubmit,
	handleBack,
	contactNumber,
}: IProps) => (
	<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
		{(formik) => (
			<Form id='cancellation-reason-form' data-test-id='cancellation-reason-form'>
				<FormikLogErrors />
				<Box sx={{ mb: '40px' }}>
					<RadioListField
						id='cancellation-reason'
						label='Select a reason for cancelling'
						options={dropdowns.reason}
						value={formik.values.reason}
						onChange={(value) => {
							formik.setFieldValue('reason', value);
						}}
						hasError={formik.touched.reason && Boolean(formik.errors.reason)}
						helperText={formik.touched.reason && formik.errors.reason}
					/>
				</Box>

				<Box sx={{ mt: formik.errors.reason?.length ? '1rem' : 0 }}>
					<Alert severity='info' variant='outlined' sx={{ mb: '4rem', borderRadius: '4px', a: { color: 'inherit' } }}>
						<CancellationReasonInfoText contactNumber={contactNumber} />
					</Alert>
					<ActionButtonWrapper>
						<Button
							startIcon={<ArrowBack />}
							variant='text'
							size='medium'
							sx={{ color: 'primary.dark' }}
							onClick={() => {
								handleBack(!!formik.values.reason);
							}}
						>
							Go back
						</Button>
						<Button size='medium' variant='contained' type='submit'>
							Continue to cancellation dates
						</Button>
					</ActionButtonWrapper>
				</Box>
			</Form>
		)}
	</Formik>
);

export default CancellationReasonForm;
